import css from 'styled-jsx/css';
import { colors, fontSizes } from '../../../themes';

export default css`
  .snippet {
    background: transparent;
    display: block;
    padding: 0.8em;
  }

  h2 {
    font-size: 14.4px;
    font-weight: 700;
    line-height: 1.2;
    color: #333;
    display: block;
    margin-bottom: 0.2em;
  }

  .snippet.visited h2 {
    color: ${colors.purpleLight};
  }

  .new {
    padding: 2px 3px;
    border-radius: 3px;
    color: #fff;
    clear: both;
    font-weight: 100;
    text-transform: uppercase;
    margin: 0 5px 0 0;
    line-height: 13px;
    background: ${colors.green};
    font-size: ${fontSizes.verySmall};
  }

  .company_location {
    margin-bottom: 0.25em;
  }

  .company {
    font-size: 14.4px;
    color: #327c50;
    display: inline-block;
  }

  .salary {
    font-size: 14.4px;
    margin: 0;
    margin-bottom: 0.6em;
  }

  .date {
    font-size: 12px;
    color: #999;
    margin: 0;
  }

  .date::first-letter {
    text-transform: capitalize;
  }

  .few-results-location-message,
  .few-results-profession-message {
    margin: -3px 0 6px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${colors.orange};
    font-weight: 600;
    font-size: ${fontSizes.small};
  }
`;



// WEBPACK FOOTER //
// ./app/common/Snippet/jobs/styles.js